import React from 'react';
import { motion } from 'framer-motion';

interface FooterProps {
  className?: string;
  delay?: number;
}

const Footer: React.FC<FooterProps> = ({ className = '', delay = 0.7 }) => {
  // Extract build hash from main JS file loaded in the page
  const [buildHash, setBuildHash] = React.useState<string>('unknown');

  React.useEffect(() => {
    try {
      // Find the main JS script tag
      const scripts = Array.from(document.getElementsByTagName('script'));
      const mainScript = scripts.find(script => script.src.includes('/static/js/main.'));

      if (mainScript) {
        const match = mainScript.src.match(/main\.([a-f0-9]+)\.js/);
        if (match && match[1]) {
          setBuildHash(match[1].substring(0, 8)); // Show first 8 characters
        }
      }
    } catch (error) {
      console.warn('Could not extract build hash:', error);
    }
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay }}
      className={`text-center text-xs text-gray-500 py-4 space-y-2 ${className}`}
    >
      <div>
        <a
          href="/terms.html"
          className="text-primary-600 hover:text-primary-800 underline mr-4"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>
        <a
          href="/privacy.html"
          className="text-primary-600 hover:text-primary-800 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
      <div className="flex items-center justify-center gap-2">
        <span>AutoTaxPilot™ is a product of Larson Raymond Rockwell</span>
      </div>
      <div className="text-[10px] text-gray-400 font-mono">
        Build: {buildHash} • v{process.env.REACT_APP_VERSION || '1.0.0'}
      </div>
    </motion.div>
  );
};

export default Footer;
